import * as moment from 'moment';
import { AppointmentSchedulingConfiguration } from '../config/appointment_scheduling_configuration';
import { UpcomingAppointmentsQuery } from '../queries/upcoming_appointments_query';
import {
  IAppointment,
  IAppointmentCard,
  IAppointmentDetails,
  IAppointmentRequest
} from '../types/appointment_interfaces';
import { IOrganizer } from '../types/appt_interfaces';

export class AppointmentRemindersServant {
  notificationDelegate: any;

  constructor(
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    private phxNotificationDelegate: any,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration
  ) {
    this.notificationDelegate = this.phxNotificationDelegate.restrictTo(
      this.ngAppointmentSchedulingConfiguration.config.notificationHandle
    );
  }

  private _generateNotification(content: string, icon: string): void {
    this.notificationDelegate.create({
      status: 'info',
      showIcon: true,
      iconClass: icon,
      content,
      dismissOnTimeout: false
    });
  }

  get trigger() {
    return this.notificationDelegate;
  }

  generateUpcomingAppointmentReminders(): void {
    _.forEach(this.ngUpcomingAppointmentsQuery.result().upcomingAppointments, (appointment: IAppointment) => {
      if (!appointment.is_cancelled) {
        const startTime: moment.Moment = moment.unix(appointment.start_timestamp);
        const day: string = startTime.isSame(moment(), 'day') ? ' today' : 'tomorrow';
        if (startTime.diff(moment(), 'hours') < 24) {
          const message: string =
            `<strong class="font-bold">Friendly Reminder</strong>
                <p class="text">
                  You have an appointment with your <span phx-feature="student-platform.roles.advisor-title.lowercase">advisor</span> ` +
            day +
            ` @ ` +
            startTime.format('h:mm a') +
            `
                </p>`;
          this._generateNotification(message, 'eab-icon eab-icon-information');
        }
      }
    });
  }

  generateAppointmentRequestReminders(): void {
    _.forEach(
      this.ngUpcomingAppointmentsQuery.result().appointmentRequests,
      (appointmentRequest: IAppointmentRequest) => {
        const advisorName: string = appointmentRequest.creator.first_name + ' ' + appointmentRequest.creator.last_name;
        const message: string =
          `<strong class="font-bold">Appointment Request! </strong>
                <p class="text">` +
          advisorName +
          ` requests that you schedule an appointment </p>`;

        this._generateNotification(message, 'eab-icon type-calendar eab-icon-calendar');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointment_reminders_servant.ts